import { render, staticRenderFns } from "./FollowUpDashboardDetailComponent.vue?vue&type=template&id=264254dd&scoped=true&"
import script from "./FollowUpDashboardDetailComponent.vue?vue&type=script&lang=js&"
export * from "./FollowUpDashboardDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpDashboardDetailComponent.vue?vue&type=style&index=0&id=264254dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264254dd",
  null
  
)

export default component.exports